export default function SiteDeclaration() {
  return (
    <div className="text-text px-2">
      <p>
        The minimum age for participation on flirtybum.com is at least 18, or
        above the age of majority in the state where you reside. The site is
        optimized for desktop, mobile phones and tablets. flirtybum.com is a
        social platform, for men and women who are looking for a fun, flirty or
        exciting contact. Every day, hundreds of new members sign up. Based on
        your profile settings, you will receive match suggestions. However, you
        can also use our search functions and browse for profiles yourself. This
        is completely up to you. flirtybum.com is designed for pleasure and
        entertainment. Fictional entertainers' profiles marked with a heart icon
        are for entertainment purposes only, physical contact with these
        profiles is not possible. We strongly advise you to read our Terms and
        Conditions before using our service.
      </p>

      <h1>
        18 U.S.C. 2257 and 2257A Record-keeping Requirements Compliance
        Statement
      </h1>
      <p>
        Any records required to be maintained by the website operator pursuant
        to 18 U.S.C. §§ 2257 and 2257A and their applicable regulations are kept
        by the following organization at the following address. PWR Network
        Limited Souniou 13 Agia Fyla 3116 Limassol Cyprus. All models warrant
        that they are a consenting adult over the age of eighteen (18) years and
        the age of majority in her/his legal jurisdiction and have accurately
        filled out and signed all of the required age verification and models
        release documents and submitted valid identification.
      </p>
    </div>
  );
}
